import { Link, useSearchParams } from "react-router-dom"
import { ArrowLeft } from "lucide-react"

/**
 * Zurueck in die Suche — dorthin, wo man hergekommen ist.
 *
 * Wer aus der Vollansicht eines Kontakts, Vorgangs oder Anrufs zurueckwill,
 * landete bisher auf der jeweiligen Listenseite und musste seine Suche neu
 * tippen. Der Link hier bringt den Suchbegriff UND die getroffene Auswahl
 * mit, sodass die Ansicht wieder so dasteht wie vorher.
 *
 * Erscheint nur, wenn `?von=suche` in der Adresse steht — sonst ist die Seite
 * ganz normal aufgerufen worden und ein „Zurueck zur Suche" waere gelogen.
 */
export function zurueckLink(zusatz?: Record<string, string | number | null | undefined>): string {
  const p = new URLSearchParams()
  p.set("von", "suche")
  const aktuell = new URLSearchParams(window.location.search)
  for (const schluessel of ["q", "contact_id", "project_id", "phone", "tenant"]) {
    const wert = aktuell.get(schluessel)
    if (wert) p.set(schluessel, wert)
  }
  for (const [k, v] of Object.entries(zusatz || {})) {
    if (v !== null && v !== undefined && v !== "") p.set(k, String(v))
  }
  return p.toString()
}

export function ZurueckZurSuche({
  stil, ersatz,
}: {
  stil?: React.CSSProperties
  /** Wohin, wenn man NICHT aus der Suche kommt. Ohne das rendert die
   *  Komponente in dem Fall nichts. */
  ersatz?: { to: string; label: string }
}) {
  const [params] = useSearchParams()
  const ausSuche = params.get("von") === "suche"

  if (!ausSuche && !ersatz) return null

  let ziel = ersatz?.to || "/projekte"
  let label = ersatz?.label || "Zur Suche"
  if (ausSuche) {
    const p = new URLSearchParams()
    for (const schluessel of ["q", "contact_id", "project_id", "phone"]) {
      const wert = params.get(schluessel)
      if (wert) p.set(schluessel, wert)
    }
    ziel = p.toString() ? `/projekte?${p}` : "/projekte"
    label = "Zurück zur Suche"
  }

  return (
    <Link
      to={ziel}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13,
        color: "#475569", textDecoration: "none", marginBottom: 14, ...stil,
      }}
    >
      <ArrowLeft style={{ width: 14, height: 14 }} />
      {label}
    </Link>
  )
}
